import React from 'react';
import CoverImage from './CoverImage';
import NoteContent from './NoteContent';
import EditorHeader from './EditorHeader';
import { NoteComment } from '@/types/note';
import { useTheme } from "next-themes";
import { getThemeColor } from "@/utils/colorUtils";

interface EditorContentProps {
  title: string;
  content: string;
  externalRevision?: number;
  color: string;
  coverImage: string | null;
  setTitle: (title: string) => void;
  setContent: (content: string) => void;
  setCoverImage: (url: string | null) => void;
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  handleTextSelection: () => void;
  comments: NoteComment[];
  isWysiwygMode: boolean;
  onGetCurrentElement?: (element: HTMLTextAreaElement | HTMLDivElement | null) => void;
  onOpenCommentForText?: (start: number, end: number, commentId: string) => void;
}

const EditorContent: React.FC<EditorContentProps> = ({
  title,
  content,
  externalRevision = 0,
  color,
  coverImage,
  setTitle,
  setContent,
  setCoverImage,
  textareaRef,
  handleTextSelection,
  comments,
  isWysiwygMode,
  onGetCurrentElement,
  onOpenCommentForText,
}) => {
  const { theme } = useTheme();
  const themeColor = getThemeColor(color, theme === 'dark');
  return (
    <div className="space-y-4">
      <EditorHeader 
        content={content}
        title={title}
        coverImage={coverImage}
      />
      
      <CoverImage 
        coverImage={coverImage} 
        onCoverImageUpload={setCoverImage}
      />
      
      <NoteContent
        title={title}
        content={content}
        externalRevision={externalRevision}
        onTitleChange={setTitle}
        onContentChange={setContent}
        textareaRef={textareaRef}
        onTextSelection={handleTextSelection}
        backgroundColor={themeColor}
        comments={comments}
        isWysiwygMode={isWysiwygMode}
        onGetCurrentElement={onGetCurrentElement}
        onOpenCommentForText={onOpenCommentForText}
      />
    </div>
  );
};

export default EditorContent;